import styled from '@emotion/styled'

export const StyledNotFoundPage = styled.div`

    /* padding: 20px;
    height: 100vh; */
    
`